import styled from 'styled-components';

const MyCarsContentWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
`;

const DisableAutoPayWrapper = styled.div`
  background-color: ${(props) => props.theme.color.neutral.v200};
  max-width: 1800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 10px 24px 46px;
  max-width: 1800px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 10px 32px 46px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding-bottom: 40px;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

export { MyCarsContentWrapper, DisableAutoPayWrapper, SpinnerWrapper };
